import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'E-Mail Adresse bestätigen',
  [OnboardingStep.BusinessInfo]: 'Details zu deinem Geschäft hinzufügen',
  [OnboardingStep.PersonalInfo]: 'Füge deine persönlichen Informationen hinzu',
  [OnboardingStep.ShippingInfo]: 'Lieferdaten hinzufügen (Versand Terminal, etc)',
  [OnboardingStep.BankInfo]: 'Bankverbindung für Auszahlungen hinzufügen',
  [OnboardingStep.TaxInfo]: 'Besitzt du eine USt.-ID?',
  [OnboardingStep.BusinessDocs]: 'Unternehmen verifizieren',
  [OnboardingStep.PersonalDocs]: 'Identitätsnachweisdokument',
  [OnboardingStep.InfoSubmission]: 'Auszahlung erhalten',
  confirm_info_gateway: 'Auszahlung erhalten – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Zahlungsinformationen',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobile App',
  [OnboardingStep.DeliveryStructure]: 'Lieferstruktur',
  [OnboardingStep.Contract]: 'Vereinbarung/ Vertrag',
  [OnboardingStep.ContractPayment]: 'Vertragszahlung',
  [OnboardingStep.PromoCode]: 'Promo-Code',
};
